<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <!-- Linha 1 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Espigas com Outros Defeitos</mat-label>
                                <input matInput id="txtEspigasOutrosDefeitos" #txtEspigasOutrosDefeitos maxlength="3"
                                    formControlName="total_espigas_outros_defeitos" currencyMask
                                    (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtEspigasOutrosDefeitos.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_espigas_outros_defeitos)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo de Defeito</mat-label>
                                <mat-select #txtTurno_amostragem formControlName="tipo_defeito" disableCenteringOption
                                    multiple  (selectionChange)="checkOutroDefeitosIsEnabled()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTipoDefeito($event.target.value)">
                                    <mat-option *ngFor="let item of listTipoDefeito" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_defeito)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md" *ngIf="tipoDefeitosIsEnabled">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Descreva o defeito</mat-label>
                              <input matInput formControlName="outro_defeito">
                              <mat-error>{{hasErrorFormControl(formulario.controls.outro_defeito)}}</mat-error>
                            </mat-form-field>
                          </div>
                    </div>

                    <!-- Linha 2 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Outros Defeitos (%)
                                </mat-label>
                                <input matInput id="txtOutrosDefeitosPrc" #txtOutrosDefeitosPrc maxlength="10"
                                    formControlName="outros_defeitos_prc" [readonly]="!tipoDefeitosIsEnabled"
                                    [ngClass]="{'InputBlockColor' : !tipoDefeitosIsEnabled}" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtOutrosDefeitosPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.outros_defeitos_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>